import {
  addressSchema,
  addressUI,
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info--mailing-address-title'];
const DESC_TEXT = content['vet-info--mailing-address-description'];
const ADDRESS_MATCH_LABEL = content['vet-info--address-match-label'];

const ADDRESS_PROPS = FULL_SCHEMA.properties.veteranAddress.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    veteranAddress: addressUI(),
    'view:doesMailingMatchHomeAddress': yesNoUI(ADDRESS_MATCH_LABEL),
  },
  schema: {
    type: 'object',
    required: ['veteranAddress', 'view:doesMailingMatchHomeAddress'],
    properties: {
      veteranAddress: addressSchema({ extend: ADDRESS_PROPS }),
      'view:doesMailingMatchHomeAddress': yesNoSchema,
    },
  },
};
